<template>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
                <v-card class="elevation-1">
                    <v-card-text>
                        <v-form @submit.prevent="onLogin()">
                            <v-text-field
                                v-validate="'required|email'"
                                prepend-icon="person"
                                name="Email"
                                label="Email"
                                :error-messages="errors.collect('email')"
                                data-vv-name="email"
                                required
                                v-model="user.email"
                            ></v-text-field>
                            <v-text-field
                                    v-validate="'required'"
                                    prepend-icon="lock"
                                    name="Password"
                                    label="Password"
                                    v-model="user.password"
                                    type="password"
                                    :error-messages="errors.collect('password')"
                                    data-vv-name="password"
                                    required
                            >
                            </v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn :to="{ name: 'forgot'}" outline color="error">Forgot Password?</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="isSubmitting" color="primary" @click="onLogin()">Login</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import User from '../../models/user'
import { mapActions } from 'vuex'

export default {
  name: 'Login',
  data () {
    return {
      user: new User(process.env.VUE_APP_LOGIN_EMAIL, process.env.VUE_APP_LOGIN_PASSWORD),
      isSubmitting: false
    }
  },
  created () {
    this.setTitle({ title: 'Login' })
  },
  methods: {
    ...mapActions(
      'application', {
        setTitle: 'setTitle'
      }
    ),
    ...mapActions(
      'auth', {
        login: 'login'
      }
    ),
    onLogin () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.isSubmitting = true
          this.internalLogin()
        } else {
          for (let e of this.$validator.errors.all()) {
            this.$snackbar.show(e)
          }
        }
      })
    },
    internalLogin () {
      this.login(this.user)
        .then(() => {
          this.$snackbar.show('Logged in')
          this.$router.replace({ name: 'search' })
        })
        .catch(error => {
          this.$log.debug(error)
          this.$snackbar.show(error.response.data.data.message)
        }).finally(() => {
          this.user.password = process.env.VUE_APP_LOGIN_PASSWORD
          this.isSubmitting = false
        })
    }
  }
}
</script>

<style scoped>

</style>
